import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            POST /mediasessions/mpaas/{"{"}spaceId{"}"}/streams/states
      </h1>
        </div>
        <p>Set MPAAS end-point sessions streams states.</p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>spaceId</td>
                <td>The ID of the space</td>
                <td>Path</td>
                <td>Yes</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p />
        <table className="table table-striped table-bordered table-condensed">
          <tbody valign="top">
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Location</th>
              <th>Required</th>
              <th>Default Value</th>
            </tr>
            <tr>
              <td>streams</td>
              <td>Array of streams to be updated</td>
              <td>Path</td>
              <td />
              <td />
            </tr>
            <tr>
              <td>streams.mdsrvSessionId</td>
              <td>mpaas end-point sessionid to be updated</td>
              <td>Path</td>
              <td />
              <td />
            </tr>
            <tr>
              <td>streams.audioMute</td>
              <td />
              <td>Path</td>
              <td />
              <td />
            </tr>
            <tr>
              <td>streams.videoMute</td>
              <td />
              <td>Path</td>
              <td />
              <td />
            </tr>
            <tr>
              <td>streams.userId</td>
              <td>Id of the user to be updated</td>
              <td>Path</td>
              <td />
              <td />
            </tr>
            <tr>
              <td>streams.userType</td>
              <td>Type of the user to be updated</td>
              <td>Path</td>
              <td />
              <td />
            </tr>
          </tbody>
        </table>
        <p />
        <h2>Authentication</h2>
        <p>
          JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator
    </p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer and PERM_TOPIC_READ</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/mediasessions//mpaas/{"{"}spaceId{"}"}/streams/states
    </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
    </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
    </pre>
        <h4>Post Body</h4>
        <pre className="javascript">
{`{
  "streams" : [
    {
      "userId": "5efc********************",
      "userType": "admin",
      "mdsrvSessionId": "e7249686e*******************************",
      "audioMute" : true,
      "videoMute" : false
    }
  ]
}`}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"data" : [{"\n"}
          {"    "}"OK"{"\n"}
          {"  "}]{"\n"}
          {"}"}
          {"     "}
          {"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
